"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./ComparisonPrice.css");
require("./ComparisonPrice.mobile.css");
require("./ComparisonPrice.tablet.css");
var PriceContainer_1 = require("../../../PriceContainer/PriceContainer");
var PriceContainerProps_1 = require("../../../PriceContainer/PriceContainerProps");
var Label_1 = require("../../../../atoms/Label");
var LabelProps_1 = require("../../../../atoms/Label/LabelProps");
var utils_1 = require("../../../../../utils/utils");
var Button_1 = require("../../../../atoms/Button");
var ButtonProps_1 = require("../../../../atoms/Button/ButtonProps");
var ComparisonPrice = /** @class */ (function (_super) {
    __extends(ComparisonPrice, _super);
    function ComparisonPrice() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComparisonPrice.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { "data-test-id": this.props.testId },
            React.createElement("div", { className: [styles.fontBold, styles.priceSm].join(' ') },
                React.createElement(PriceContainer_1.default, { testId: utils_1.default(this.props.testId, 'PriceContainer'), data: this.props.data.price, options: { type: PriceContainerProps_1.PricingType.LARGE } })),
            React.createElement("div", null,
                React.createElement(Label_1.default, { testId: utils_1.default(this.props.testId, 'Label'), data: { text: this.props.data.text }, options: { size: LabelProps_1.LabelSizes.SMALL, className: styles.priceText } })),
            this.props.data.discount && this.props.data.discount.text &&
                React.createElement(Button_1.default, { data: { text: this.props.data.discount && this.props.data.discount.text }, events: { onClick: function () { _this.props.events.discountLinkEvents(_this.props.data.isCurrentPlan); } }, options: {
                        className: styles.link,
                        role: ButtonProps_1.ButtonRole.LINK,
                        type: ButtonProps_1.ButtonType.TEXT,
                    } }),
            this.props.data.discount && this.props.data.discount.text === '' &&
                React.createElement("div", { className: styles.blankDiv }, " \u00A0")));
    };
    return ComparisonPrice;
}(React.Component));
exports.default = ComparisonPrice;
//# sourceMappingURL=ComparisonPrice.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/CardComparisonContainer/components/ComparisonPrice/ComparisonPrice.js
// module id = 1324
// module chunks = 8